import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $colorDivBackground: string | null }>`
	all: unset;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	background-color: ${(props) =>
		props.$colorDivBackground === null
			? 'transparent'
			: props.$colorDivBackground};
	gap: 1rem;
`;

export const notice = styled.p<{ $colorFont: string | null }>`
	font-size: 1.3rem;
	color: ${(props) =>
		props.$colorFont === null
			? color.interface.white
			: color.interface.darkgray};
	@keyframes flashing {
		from {
			opacity: 1;
		}
		to {
			opacity: 0;
		}
	}
	font-family:
		'nunito-regular',
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		Roboto,
		Oxygen,
		Ubuntu,
		Cantarell,
		'Open Sans',
		'Helvetica Neue',
		sans-serif;
	animation: linear;
	animation-name: flashing;
	animation-duration: 1s;
	animation-iteration-count: infinite;
	animation-direction: alternate-reverse;
`;
